import TeamOptions from './TeamOptions';

export default TeamOptions;
